import { datajs, datajsAll } from '../shared/utils';
import Swiper, { FreeMode, Navigation, Pagination } from 'swiper';
import { Modal } from 'bootstrap';

export default class CarouselBlock {
	static init() {
		const carousels = datajsAll('carousel-block');

		carousels.forEach((carousel) => {
			this.carouselConfig(carousel);
			this.carouselModal(carousel);
		});
	}

	// Setup Carousel
	static carouselConfig(carousel) {
		const carouselWrapper = carousel.closest('[data-js~=carousel]');
		const carouselContent = datajs('carousel-content', carouselWrapper);
		const isInline = carouselWrapper.classList.contains('o-carousel--inline');
		let carouselInstance = null;

		let breakpoints = {
			768: {
				spaceBetween: 16,
			},
			992: {
				spaceBetween: 32,
			},
			1200: {
				spaceBetween: 48,
			},
		};

		if (isInline) {
			breakpoints = {
				768: {
					spaceBetween: 32,
					freeMode: false,
				},
				992: {
					spaceBetween: 48,
					freeMode: false,
				},
				1200: {
					spaceBetween: 80,
					freeMode: false,
				},
			};
		}

		// Only prepare for carousel if there are more than one slide
		if (carousel.dataset.slideCount > 1) {
			// eslint-disable-next-line no-new
			carouselInstance = new Swiper(carousel, {
				modules: [FreeMode, Navigation, Pagination],
				init: false,
				speed: 500,
				slidesPerView: 'auto',
				freeMode: true,
				spaceBetween: 12,
				centeredSlides: true,

				breakpoints: breakpoints,

				navigation: {
					nextEl: '[data-js~=carousel-next]',
					prevEl: '[data-js~=carousel-prev]',
				},

				pagination: {
					el: datajsAll('carousel-pagination', carouselWrapper),
					bulletClass: 'm-sliderPagination__item',
					bulletActiveClass: 'is-active',
					clickable: true,
				},
			});
		}

		// Take content from the active carousel slide and put it into the carousel content container
		function updateCarouselContent(swiper) {
			const index = swiper?.activeIndex + 1 || 1;
			const nextSlide = carousel.querySelector('.swiper-slide:nth-child(' + index + ')');
			const nextSlideContentContainer = datajs('carousel-slide-content', nextSlide);
			let nextSlideContent = '';

			if (nextSlideContentContainer) {
				nextSlideContent = nextSlideContentContainer.innerHTML;
			}

			carouselContent.innerHTML = nextSlideContent;
		}

		if (carouselContent && carouselInstance) {
			// Set initial carousel content to the first slide
			carouselInstance.on('afterInit', updateCarouselContent);
			carouselInstance.on('slideChange', updateCarouselContent);
		}

		// Only init carousel if it has more than one slide
		if (carouselInstance) {
			carouselInstance.init();
		} else {
			updateCarouselContent();
		}
	}

	// Setup Carousel Modal
	static carouselModal(carousel) {
		const buttons = datajsAll('video-slide-play-button', carousel);
		const carouselWrapper = carousel.closest('[data-js~=carousel]');
		const carouselModalElement = datajs('video-modal', carouselWrapper);
		const carouselModalElementContent = datajs('video-modal-content', carouselWrapper);
		const carouselModal = new Modal(carouselModalElement);

		// Show modal event
		carouselModalElement.addEventListener('shown.bs.modal', function () {
			const videoElement = carouselModalElementContent.querySelector('video');
			const iframe = carouselModalElementContent.querySelector('iframe');

			if (videoElement) {
				videoElement.play();
			} else if (iframe) {
				iframe.setAttribute('src', iframe.dataset.src + '&autoplay=1');
			}
		});

		// Hide modal event
		carouselModalElement.addEventListener('hidden.bs.modal', function () {
			const videoElement = carouselModalElementContent.querySelector('video');
			const iframe = carouselModalElementContent.querySelector('iframe');

			if (videoElement) {
				videoElement.pause();
			} else if (iframe) {
				iframe.removeAttribute('src');
			}
		});

		buttons.forEach((button) => {
			const currentVideoSlide = button.closest('[data-js~=video-slide]');
			const currentVideoElement = datajs('video-slide-video', currentVideoSlide);

			button.addEventListener('click', function (e) {
				e.preventDefault();
				carouselModalElementContent.innerHTML = currentVideoElement.innerHTML;
				carouselModal.show();
			});
		});
	}
}
